import firebase from 'firebase/app';

import config from 'config/firebase.config';

firebase.initializeApp(config);

export default firebase;
